import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import {
  sendMessage,
  uploadFiles,
  checkUrlStatus,
  InvokeMatrixApi,
  upload_FilesOnly,
  getUserInfo,
  getChallenges,
  submitChallenge,
  UserCreaditStatus,
  FetchUserSettings,
  FetchAllHeygenVoicesForSettings,
  getUsageDataForCallingAgent,
} from "./WorkspaceUtils";
import ImageFormat from "../components/workspace/settingBar/ImageSettings/ImageFormat";
import sourceUrl from "../api/Source.api";
import axios from "axios";
import {
  fetchAvatars,
  fetchBackgrounds,
} from "../components/workspace/settingBar/synthesiaSettings/videoSettingsAPI";

const WorkspaceContext = createContext();
export const useWorkspace = () => useContext(WorkspaceContext);

const WorkspaceProvider = ({ children }) => {
  // threadHistory
  const [threads, setThreads] = useState([]);
  // [{ sender: enum("modalX", "user"), content: content, file(optional):{url: url, urlStatus: enum("processing", "processed")} }, ...]
  const [currentThread, setCurrentThread] = useState([]);
  // boolean to check if the thread is waiting for a response
  const [waitThread, setWaitThread] = useState(false);
  // threadSettings {synthesiaSettings: {}, synthesiaAvatar: {}, synthesiaVoice: {}}
  const [threadSettings, setThreadSettings] = useState({});
  // [{ type:enum("link", "file"), name: string, file(if type file): File, link(if type link):weblink, status: enum("uploading", "uploaded", "upload failed"), fileId: string }, ...]
  const [threadFiles, setThreadFiles] = useState([]);
  // "string" Current thread ID for sending messages
  const [threadId, setThreadId] = useState(null);
  const [currentHistoryId, setCurrentHistoryId] = useState(null);
  const [editClick, setEditClick] = useState(false);
  const [input, setInput] = useState("");
  const stopMessageIdRef = useRef([]);
  const [stopMessageIDRef, setStopMessageIDRef] = useState([]);
  const [currentStopGenerationMessageId, setCurrentStopGenerationMessageId] =
    useState(null);
  const [visibleStopGenerationButton, setVisibleStopGenerationButton] =
    useState(false);

  // Image Settings starts==============================
  const [imageFormat, setImageFormat] = useState("png");
  const [imageModel, setImageModel] = useState("3d-model");
  const [imageRatio, setImageRatio] = useState("1:1");
  // Image settings ends =================================

  // ====================Video settings starts ============================
  const [selectedVideoGenerationPlatform, setSelectedVideoGenerationPlatform] =
    useState("Avatar");
  const [videoAvatar, setVideoAvatar] = useState(null);
  const [videoBackground, setVideoBackground] = useState(null);
  const [videoVoice, setVideoVoice] = useState(null);
  const [videoLogo, setVideoLogo] = useState(null);
  const [videoAvatarLanguage, setVideoAvatarLanguage] = useState(null);
  const [personalAvatar, setPersonalAvatar] = useState(null);
  // ====================Video settings ends ============================

  // ==================== Audio settings starts ============================
  const [audioLanguage, setAudioLanguage] = useState(null);
  const [audioVoice, setAudioVoice] = useState(null);
  const [audioVoiceObject, setAudioVoiceObject] = useState(null);
  // ==================== Audio settings ends ==============================

  // ==================== PPT settings starts ============================
  const [levelOfTextDetail, setLevelOfTextDetail] = useState("medium")
  const [selectedTone, setTone] = useState("professional");
  const [audience, setAudience] = useState("business executives");
  const [language, setLanguage] = useState("en");
  const [imageSource, setImageSource] = useState("aiGenerated")
  const [imageStyle, setImageStyle] = useState("modern professional")
  const [pptImageModel, setPPTImageModel] = useState("gamma-default");
  const [slideCount, setSlideCount] = useState(10);
  const [themeStyle, setThemeStyle] = useState("light");
  const [typographyStyle, setTypographyStyle] = useState("sans");
  const [layoutStyle, setLayoutStyle] = useState("balanced");
  const [titleStyle, setTitleStyle] = useState("clean");
  const [additionalInstructions, setAdditionalInstructions] = useState("Make the presentation visually engaging with practical examples")

  // ==================== PPT settings ends ============================


  const [sending, setSending] = useState(false);

  const [templateId, setTemplateId] = useState(1);

  const [historyFiles, setHistoryFiles] = useState([]);

  const [Today, setToday] = useState([]);
  const [Yesterday, setYesterday] = useState([]);
  const [ThisWeek, setThisWeek] = useState([]);
  const [ThisMonth, setThisMonth] = useState([]);
  const [PrevMonth, setPrevMonth] = useState([]);
  const [Months, setMonths] = useState({});
  const [Years, setYears] = useState({});

  const [showLeftsideBar, setShowLeftsideBar] = useState(true);
  const [showRightsideBar, setShowRightsideBar] = useState(true);

  const [showFirstVisitModal, setShowFirstVisitModal] = useState(false);
  const [showVideoSettings, setShowVideoSettings] = useState(false);
  const [showImageSettings, setShowImageSettings] = useState(false);
  const [showPptSettings, setShowPptSettings] = useState(false);
  const [showAudioSettings, setShowAudioSettings] = useState(false);
  const [subscribe, setSubscribe] = useState(null);
  const [subscribeType, setSubscribeType] = useState(null);
  const [showCallingAgentIconOnWorkspace, setShowCallingAgentIconOnWorkspace] =
    useState(false);
  const [shareModalforSocialMedia, setShareModalforSocialMedia] =
    useState(false);

  const [suggestedPrompt, setSuggestedPrompt] = useState("");
  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 992);
  const [showSettingBar, setShowSettingBar] = useState(true);
  const [showSuggested, setShowSuggested] = useState(true);
  const [languages, setLanguages] = useState([]);
  const [voices, setVoices] = useState([]);
  const [categories, setCategories] = useState([]);
  const [backgrounds, setBackgrounds] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [avatars, setAvatars] = useState([]);
  const [avatarsloading, setAvatarsLoading] = useState(true);
  const [showPersonalAvatarModal, setShowPersonalAvatarModal] = useState(false);
  const [voiceloading, setVoiceLoading] = useState(null);
  const [Audiolanguages, setAudioLanguages] = useState(null);
  const [audioSettingVoices, setAudioSettingVoices] = useState(null);
  const [audioSettingVoicesloading, setAudioSettingVoicesLoading] =
    useState(false);
  const [audioSettinglanguagesloading, setAudioSettingLanguagesLoading] =
    useState(false);
  const [openWebsiteTrackModal, setOpenWebsiteTrackModal] = useState(false);
  const [freshUser, setFreshUser] = useState("loading");
  const [onBoardingData, setOnBoardingData] = useState(null);

  // Web tracking

  const [iswebTrackClicked, setIswebTrackClicked] = useState(false);
  const [selectedWeb, setSelectedWeb] = useState("");
  const [reloadForSummary, setReloadForSummary] = useState(true);
  const [currentWebsiteLinkedId, setCurrentWebsiteLinkedId] = useState(null);
  const [
    selectedOneClickButtonFromWebtrackNotificationMsg,
    setSelectedOneClickButtonFromWebtrackNotificationMsg,
  ] = useState("");
  const [notificationTextFromWebTracking, setNotificationTextFromWebTracking] =
    useState("");
  const [webTrackingLoading, setWebTrackingLoading] = useState(false);
  const [currentWebs, setCurrentWebs] = useState([]);
  const [refetchClicked, setRefetchClicked] = useState(false);
  const [webTrackingWebsiteLoading, setWebTrackingWebsiteLoading] =
    useState(false);

  // ====================VideoGen(Video With Caption) settings starts ============================

  const [genVideoAudioSettingsLoading, setGenVideoAudioSettingsLoading] =
    useState(true);
  const [genVideoSettingVoices, setGenVideoSettingVoices] = useState([]);
  const [genVideoLanguage, setGenVideoLanguage] = useState([]);
  const [selectedGenVideoLanguage, setSelectedGenVideoLanguage] =
    useState(null);
  const [genVideoVoice, setGenVideoVoice] = useState(null);
  const [genVideoVoicesLoading, setGenVideoVoicesLoading] = useState(true);
  const [selectedGenVideoVoice, setSelectedGenVideoVoice] = useState(null);
  const [minDimensionPixels, setMinDImensionPixels] = useState(null);
  // const [selectCaptionFontSizeForVideoGen, setSelectCaptionFontSizeForVideoGen] = useState(null);
  // const [selectCaptionFontWeightForVideoGen, setSelectCaptionFontWeightForVideoGen] =useState(null);
  const [selectedAspectRatioForVideoGen, setSelectedAspectRatioForVideoGen] =
    useState(null);
  const [selectedaspectRatioForVideoGen, setSelectedaspectRatioForVideoGen] =
    useState(null);
  const [selectedHeightForVideoGen, setSelectedHeightForVideoGen] =
    useState(null);
  const [selectedWidthForVideoGen, setSelectedWidthForVideoGen] =
    useState(null);
  const [selectedCaptionFontForVideoGen, setSelectedCaptionFontForVideoGen] =
    useState("Inter");
  const [CaptionFontForVideoGen, setCaptionFontForVideoGen] = useState(null);
  const [showCaption, setShowCaption] = useState(true);
  const [captionTextColor, setCaptionTextColor] = useState({
    r: 255,
    g: 255,
    b: 255,
    a: 1,
  });
  const [captionBackgoundColor, setCaptionBackgoundColor] = useState({
    r: 0,
    g: 0,
    b: 0,
    a: 0.5,
  });
  const [selectedColorForCaptionText, setSeletedColorForCaptionText] =
    useState("#ffffff");
  const [
    selectedColorForCaptionTextBackground,
    setSelectedColorForCaptionTextBackground,
  ] = useState("FFFFFF");
  const [isBoldForCaption, setIsBoldForCaption] = useState(false);
  const [selectedAlignmentForCaption, setSelectedAlignmentForCaption] =
    useState("center");
  const [
    selectedVarticalAlignmentForCaption,
    setSelectedVarticalAlignmentForCaption,
  ] = useState("BOTTOM");
  const [captionFontSize, setCaptionFontSize] = useState("50");

  // ====================VideoGen(Video With Caption) settings end ============================

  // const [hasLink, setHasLink] = useState(false);
  // const [arrayForLinksAvalible, setArrayForLinksAvalible] = useState([]);
  const [updateWebList, setUpdateWebList] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [userInfoLoading, setUserInfoLoading] = useState(false);
  const [showTutorialModal, setShowTutorialModal] = useState(false);
  const [userMediaSettings, setUserMediaSettings] = useState(null);
  const [loadingUserMediaSettings, setLoadingUserMediaSettings] =
    useState(null);
  const [allVoiceforSettingShow, setAllVoiceforSettingShow] = useState(null);
  const [autoTypingInPromptCompleted, setAutoTypingInPromptCompleted] =
    useState(null);
  const [email, setEmail] = useState("");
  // useEffect(() => {
  //   // Check if the user has already visited
  //   const hasVisited = localStorage.getItem("hasVisitedWorkspace");

  //   if (!hasVisited) {
  //     // If not, show the modal
  //     setShowFirstVisitModal(true);
  //     // Mark as visited
  //     localStorage.setItem("hasVisitedWorkspace", "true");
  //   }
  // }, []);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [showManageMemoriesModal, setShowManageMemoriesModal] = useState(false);

  // Calling credits state
  const [showCallingCreditsModal, setShowCallingCreditsModal] = useState(false);
  const [remainingCredits, setRemainingCredits] = useState(0);

  // ==================== Calling Agent starts ============================
  const [AllDashboardData, setAllDashboardData] = useState(null);
  const [totalDetails, setTotalDetails] = useState({
    totalContact: 0,
    totalVoiceAgent: 0,
    totalLLMAgent: 0,
    totalPhoneNumber: 0,
  });
  const [callingAgentUserProfileData, setCallingAgentUserProfileData] =
    useState({
      name: "",
      country:"",
      phone: {
          country_code:  "",
          e164: "",
          number : ""
      },
      email: "",
      website: "",
      calendly_link: "",
      follow_up_notification_email: "",
      enable_follow_up_notification: false,
    });
  const [voiceAgentsAllLanguage, setVoiceAgentsAllLanguage] = useState();
  const [voiceAgentsAllPersona, setVoiceAgentsAllPersona] = useState();
  const [voiceAgentsAllPhoneNumber, setVoiceAgentsAllPhoneNumber] = useState();
  const [voiceAgentAllAIAgent, setVoiceAgentAllAIAgent] = useState(null);
  const [contactData, setContactData] = useState(null);
  const [showVoiceCallModal, setShowVoiceCallModal] = useState(false);

  //for Saving All Blogs
  const [allBlogs, setAllBlogs] = useState(null);

  //for Heygen Video Settings
  const [allHeygenVideoAvatarList, setAllHeygenVideoAvatarList] =
    useState(null);
  const [selectedAvatarForHeygenVideo, setSeletedAvatarForHeygenVideo] =
    useState({
      avatar_id: "Abigail_expressive_2024112501",
      avatar_name: "Abigail (Upper Body)",
      gender: "female",
      preview_image_url:
        "https://files2.heygen.ai/avatar/v3/1ad51ab9fee24ae88af067206e14a1d8_44250/preview_target.webp",
      preview_video_url:
        "https://files2.heygen.ai/avatar/v3/1ad51ab9fee24ae88af067206e14a1d8_44250/preview_video_target.mp4",
    });
  const [allHeygenVideoVoiceList, setAllHeygenVideoVoiceList] = useState(null);
  const [selectedAvatarVoiceForHeygenVideo, setSeletedAvatarVoiceForHeygenVideo] = useState({
    voice_id: "8zyEHKg4E13JC6KxaX1V",
    language: "English",
    gender: "other",
    name: "luffy - Voice 1",
    preview_audio:
      "https://heygen-product.s3-accelerate.amazonaws.com/voice-design/previews/8zyEHKg4E13JC6KxaX1V.mp3?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIA3FLD4S3A6M46RW4K%2F20250528%2Fus-east-2%2Fs3%2Faws4_request&X-Amz-Date=20250528T092429Z&X-Amz-Expires=604800&X-Amz-SignedHeaders=host&X-Amz-Signature=dd5f90854bb2ee88a996cd387defa30ca960000e5177aab75977574c63812d3e",
    support_pause: true,
    emotion_support: false,
    support_interactive_avatar: false,
  });
  const [voiceSpeedForHeygen, setVoiceSpeedForHeygen] = useState(1);
  const [voicePitchForHeygen, setVoicePitchForHeygen] = useState(0);
  const [voiceEmotionForHeygen, setVoiceEmotionForHeygen] =
    useState("Friendly");
  const [captionForHeygenVideo, setCaptionForHeygenVideo] = useState(false);
  const [selectedBgColorForHeygenVideo, setSeletedBgColorForHeygenVideo] =
    useState("#FFFFFF");
  const [heygenVideoTitle, setHeygenVideoTitle] = useState("");
  const [heygenAvatarScale, setHeygenAvatarScale] = useState(1);
  const [heygenAvatarOffset, setHeygenAvatarOffset] = useState({
    x: 0.0,
    y: 0.0,
  });
  const [heygenAvatarStyle, setHeygenAvatarStyle] = useState("normal");
  const [heygenVideoDimension, setHeygenVideoDimension] = useState();
  const [uploadedImageData, setUploadedImageData] = useState(null);
  const [
    heygenVideoPersonalAvatarImageId,
    setHeygenVideoPersonalAvatarImageId,
  ] = useState(null);
  const [
    isModalOpenForAvatarGenerationOption,
    setIsModalOpenForAvatarGenerationOption,
  ] = useState(false);
  const [heygenVideoWidth, setHeygenVideoWidth] = useState(1280);
  const [heygenVideoHeight, setHeygenVideoHeight] = useState(720);
  const [selectedVideoResolution, setSelectedVideoResolution] = useState({
    id: 1,
    width: 1280,
    height: 720,
    value: "720p (1280 X 720)",
  });
  const [showAvatarCreation, setShowAvatarCreation] = useState(false);
  const [
    heygenVideoPersonalAvatarGroupId,
    setHeygenVideoPersonalAvatarGroupId,
  ] = useState(null);
  const [allHeygenVideovoices, setAllHeygenVideovoices] = useState();

          // Veo Video
  const [veoVideoResolution, setVeoVideoResolution] = useState( { id: 2, width: 1920, height: 1080, value: "1920 X 1080",ratio:"16:9"})
  const [veoVideoPeopleAndFaces, setVeoVideoPeopleAndFaces] = useState("allow_all")
  const [selectedLLMModal, setSelectedLLMModal] = useState("gpt-4o")
  const [alertCallPlace, setAlertCallPlace] = useState("")

    useEffect(()=>{
    async function heygenAllVoices(){
      try{
        const res = await  FetchAllHeygenVoicesForSettings()
        const allvoice = await res.json()
        if(allvoice.status){
          // console.log("allvoice.data", allvoice?.data?.data?.voices)
          setAllHeygenVideovoices(allvoice?.data?.data?.voices)
        }else{
           console.log("error", allvoice)
        }
      }catch(error){
        console.log("error", error)
      }
    }
    if(!allHeygenVideovoices){
      heygenAllVoices()
    }
  },[])

  useEffect(() => {
    const fetchOnboardingStatus = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(`${sourceUrl}/user/onboardingStatus`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            // 'User-Agent': 'Mozilla/5.0',
          },
        });

        const { status } = response?.data?.data;

        // Update modal and hasVisitedWorkspace based on status
        if (status) {
          setShowFirstVisitModal(true); // If status is true, show video settings modal
        }
        setFreshUser(!status);
        setOnBoardingData(response?.data?.data);
        localStorage.setItem("hasVisitedWorkspace", status ? "true" : "false");
      } catch (error) {
        setFreshUser(true);
        console.error("Error fetching onboarding status:", error);
      }
    };

    fetchOnboardingStatus();
  }, []);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn");
    async function getSubscriptionStatus() {
      const res = await UserCreaditStatus(
        setSubscribe,
        setSubscribeType,
        setShowCallingAgentIconOnWorkspace
      );
    }
    if (isLoggedIn && (subscribe == null || subscribeType == null)) {
      getSubscriptionStatus();
    }
  }, [subscribe]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    async function fetchUserInfo() {
      if (token) {
        if (!userInfo && userInfoLoading == false) {
          await getUserInfo(setUserInfo, setUserInfoLoading);
        }
        // if(!backgrounds){
        //   await fetchBackgrounds(setBackgrounds)
        // }
        // if(!avatars){
        //   await fetchAvatars(setAvatars, setAvatarsLoading, setPersonalAvatar)
        // }
      }
    }
    fetchUserInfo();
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    async function FetchUserAllSettings() {
      if (token && !loadingUserMediaSettings) {
        setLoadingUserMediaSettings(true);
        const All_Settings = await FetchUserSettings();
        //  console.log(All_Settings, "All Settings");
        if (All_Settings) {
          setUserMediaSettings(All_Settings);
        } else {
          setUserMediaSettings(null);
        }
        setLoadingUserMediaSettings(false);
      }
    }
    FetchUserAllSettings();
  }, []);

  useEffect(() => {
    const fetchCallingCredits = async () => {
      try {
        const res = await getUsageDataForCallingAgent();
        const creditsData = await res.json();
        if (creditsData.status) {
          setRemainingCredits(creditsData?.data?.credit_remain);
        } else {
          console.log("error", creditsData);
        }
      } catch (error) {
        console.log("error", error);
      }
    };
    if (!remainingCredits) {
      fetchCallingCredits();
    }
  }, []);

  const clearThread = () => {
    // Clear current thread
    setCurrentThread([]);
    // clear thread id
    setThreadId(null);
    // clear thread settings
    setThreadSettings({});
    // clear thread files
    setThreadFiles([]);
    // clear history files
    setHistoryFiles([]);
    // clear current history id
    setCurrentHistoryId(null);
  };

  const value = {
    threads,
    setThreads,
    currentThread,
    setCurrentThread,
    threadSettings,
    setThreadSettings,
    threadFiles,
    setThreadFiles,
    threadId,
    setThreadId,
    currentHistoryId,
    setCurrentHistoryId,
    waitThread,
    setWaitThread,
    clearThread,
    templateId,
    setTemplateId,
    sending,
    setSending,
    historyFiles,
    setHistoryFiles,
    Today,
    setToday,
    Yesterday,
    setYesterday,
    ThisWeek,
    setThisWeek,
    ThisMonth,
    setThisMonth,
    PrevMonth,
    setPrevMonth,
    Months,
    setMonths,
    Years,
    setYears,
    showLeftsideBar,
    setShowLeftsideBar,
    showRightsideBar,
    setShowRightsideBar,
    imageFormat,
    setImageFormat,
    imageModel,
    setImageModel,
    imageRatio,
    setImageRatio,
    selectedVideoGenerationPlatform,
    setSelectedVideoGenerationPlatform,
    videoAvatar,
    setVideoAvatar,
    videoBackground,
    setVideoBackground,
    videoVoice,
    setVideoVoice,
    videoAvatarLanguage,
    setVideoAvatarLanguage,
    audioLanguage,
    setAudioLanguage,
    audioVoice,
    setAudioVoice,
    showFirstVisitModal,
    setShowFirstVisitModal,
    showVideoSettings,
    setShowVideoSettings,
    showImageSettings,
    setShowImageSettings,
    showPptSettings,
    setShowPptSettings,
    showAudioSettings,
    setShowAudioSettings,
    shareModalforSocialMedia,
    setShareModalforSocialMedia,
    editClick,
    setEditClick,
    suggestedPrompt,
    setSuggestedPrompt,
    showSidebar,
    setShowSidebar,
    showSettingBar,
    setShowSettingBar,
    showSuggested,
    setShowSuggested,
    iswebTrackClicked,
    setIswebTrackClicked,
    selectedWeb,
    setSelectedWeb,
    selectedOneClickButtonFromWebtrackNotificationMsg,
    setSelectedOneClickButtonFromWebtrackNotificationMsg,
    notificationTextFromWebTracking,
    setNotificationTextFromWebTracking,
    webTrackingLoading,
    setWebTrackingLoading,
    webTrackingWebsiteLoading,
    setWebTrackingWebsiteLoading,
    sendMessage: async (latestEntry, onboardingData) =>
      await sendMessage(
        latestEntry,
        threadId,
        threadFiles,
        threadSettings,
        setThreadId,
        templateId,
        historyFiles,
        imageFormat,
        imageModel,
        imageRatio,
        videoAvatar,
        videoBackground,
        videoVoice,
        videoAvatarLanguage,
        audioLanguage,
        audioVoice,
        onboardingData,
        selectedGenVideoVoice,
        selectedGenVideoLanguage,
        minDimensionPixels,
        selectedHeightForVideoGen,
        selectedWidthForVideoGen,
        // selectCaptionFontSizeForVideoGen,
        // selectCaptionFontWeightForVideoGen,
        isBoldForCaption,
        showCaption,
        captionBackgoundColor,
        captionTextColor,
        selectedAlignmentForCaption,
        selectedVarticalAlignmentForCaption,
        selectedCaptionFontForVideoGen,
        captionFontSize,
        selectedVideoGenerationPlatform,
        setCurrentStopGenerationMessageId,
        personalAvatar,
        selectedAvatarForHeygenVideo,
        selectedAvatarVoiceForHeygenVideo,
        selectedBgColorForHeygenVideo,
        captionForHeygenVideo,
        heygenVideoTitle,
        voiceEmotionForHeygen,
        voicePitchForHeygen,
        voiceSpeedForHeygen,
        heygenAvatarOffset,
        heygenAvatarScale,
        heygenAvatarStyle,
        heygenVideoPersonalAvatarImageId,
        heygenVideoWidth,
        heygenVideoHeight,
        veoVideoResolution,
        veoVideoPeopleAndFaces,
        selectedLLMModal,
        levelOfTextDetail,
        selectedTone,
        audience,
        imageSource,
        imageStyle,
        additionalInstructions,
        slideCount
      ),
    submitChallenge: async (latestEntry, onboardingData) =>
      await submitChallenge(
        latestEntry,
        threadId,
        threadFiles,
        threadSettings,
        setThreadId,
        templateId,
        historyFiles,
        imageFormat,
        imageModel,
        imageRatio,
        videoAvatar,
        videoBackground,
        videoVoice,
        videoAvatarLanguage,
        audioLanguage,
        audioVoice,
        onboardingData,
        selectedGenVideoVoice,
        selectedGenVideoLanguage,
        minDimensionPixels,
        selectedHeightForVideoGen,
        selectedWidthForVideoGen,
        // selectCaptionFontSizeForVideoGen,
        // selectCaptionFontWeightForVideoGen,
        isBoldForCaption,
        showCaption,
        captionBackgoundColor,
        captionTextColor,
        selectedAlignmentForCaption,
        selectedVarticalAlignmentForCaption,
        selectedCaptionFontForVideoGen,
        captionFontSize,
        selectedVideoGenerationPlatform
      ),
    getChallenges: async (latestEntry, isValidDetails, onboardingData) =>
      await getChallenges(
        latestEntry,
        isValidDetails,
        onboardingData,
        threadId,
        setThreadId
      ),
    uploadFiles: async (fileObj) =>
      await uploadFiles(fileObj, threadId, setThreadId),
    upload_FilesOnly: async (fileObj) =>
      await upload_FilesOnly(fileObj, threadId, setThreadId),
    checkUrlStatus: async (url) => await checkUrlStatus(url, threadId),
    InvokeMatrixApi: async (
      jsonRespData,
      respData,
      reqType,
      endPoint,
      reqBody,
      emailId
    ) =>
      await InvokeMatrixApi(
        jsonRespData,
        respData,
        reqType,
        threadId,
        endPoint,
        reqBody,
        emailId
      ),
    subscribe,
    setSubscribe,
    languages,
    setLanguages,
    voices,
    setVoices,
    categories,
    setCategories,
    backgrounds,
    setBackgrounds,
    selectedCategory,
    setSelectedCategory,
    avatars,
    setAvatars,
    avatarsloading,
    setAvatarsLoading,
    showPersonalAvatarModal,
    setShowPersonalAvatarModal,
    voiceloading,
    setVoiceLoading,
    Audiolanguages,
    setAudioLanguages,
    audioSettingVoices,
    setAudioSettingVoices,
    audioSettingVoicesloading,
    setAudioSettingVoicesLoading,
    audioSettinglanguagesloading,
    setAudioSettingLanguagesLoading,
    openWebsiteTrackModal,
    setOpenWebsiteTrackModal,
    freshUser,
    setFreshUser,
    onBoardingData,
    setOnBoardingData,
    reloadForSummary,
    setReloadForSummary,
    currentWebsiteLinkedId,
    setCurrentWebsiteLinkedId,
    genVideoAudioSettingsLoading,
    setGenVideoAudioSettingsLoading,
    genVideoSettingVoices,
    setGenVideoSettingVoices,
    genVideoLanguage,
    setGenVideoLanguage,
    selectedGenVideoLanguage,
    setSelectedGenVideoLanguage,
    genVideoVoice,
    setGenVideoVoice,
    genVideoVoicesLoading,
    setGenVideoVoicesLoading,
    selectedGenVideoVoice,
    setSelectedGenVideoVoice,
    minDimensionPixels,
    setMinDImensionPixels,
    // selectCaptionFontSizeForVideoGen, setSelectCaptionFontSizeForVideoGen,
    // selectCaptionFontWeightForVideoGen, setSelectCaptionFontWeightForVideoGen,
    selectedAspectRatioForVideoGen,
    setSelectedAspectRatioForVideoGen,
    selectedaspectRatioForVideoGen,
    setSelectedaspectRatioForVideoGen,
    selectedHeightForVideoGen,
    setSelectedHeightForVideoGen,
    selectedWidthForVideoGen,
    setSelectedWidthForVideoGen,
    selectedCaptionFontForVideoGen,
    setSelectedCaptionFontForVideoGen,
    CaptionFontForVideoGen,
    setCaptionFontForVideoGen,
    showCaption,
    setShowCaption,
    captionTextColor,
    setCaptionTextColor,
    selectedColorForCaptionText,
    setSeletedColorForCaptionText,
    selectedColorForCaptionTextBackground,
    setSelectedColorForCaptionTextBackground,
    isBoldForCaption,
    setIsBoldForCaption,
    selectedAlignmentForCaption,
    setSelectedAlignmentForCaption,
    selectedVarticalAlignmentForCaption,
    setSelectedVarticalAlignmentForCaption,
    captionBackgoundColor,
    setCaptionBackgoundColor,
    captionFontSize,
    setCaptionFontSize,
    // hasLink, setHasLink,
    // arrayForLinksAvalible, setArrayForLinksAvalible,
    audioVoiceObject,
    setAudioVoiceObject,
    updateWebList,
    setUpdateWebList,
    userInfo,
    setUserInfo,
    userInfoLoading,
    setUserInfoLoading,
    currentWebs,
    setCurrentWebs,
    refetchClicked,
    setRefetchClicked,
    input,
    setInput,
    stopMessageIdRef,
    stopMessageIDRef,
    setStopMessageIDRef,
    currentStopGenerationMessageId,
    setCurrentStopGenerationMessageId,
    visibleStopGenerationButton,
    setVisibleStopGenerationButton,
    subscribeType,
    setSubscribeType,
    showTutorialModal,
    setShowTutorialModal,
    userMediaSettings,
    setUserMediaSettings,
    loadingUserMediaSettings,
    setLoadingUserMediaSettings,
    allVoiceforSettingShow,
    setAllVoiceforSettingShow,
    autoTypingInPromptCompleted,
    setAutoTypingInPromptCompleted,
    email,
    setEmail,
    personalAvatar,
    setPersonalAvatar,
    showScrollButton,
    setShowScrollButton,
    showManageMemoriesModal,
    setShowManageMemoriesModal,
    showCallingCreditsModal,
    setShowCallingCreditsModal,
    remainingCredits,
    setRemainingCredits,
    callingAgentUserProfileData,
    setCallingAgentUserProfileData,
    voiceAgentsAllLanguage,
    setVoiceAgentsAllLanguage,
    voiceAgentsAllPersona,
    setVoiceAgentsAllPersona,
    voiceAgentsAllPhoneNumber,
    setVoiceAgentsAllPhoneNumber,
    voiceAgentAllAIAgent,
    setVoiceAgentAllAIAgent,
    AllDashboardData,
    setAllDashboardData,
    totalDetails,
    setTotalDetails,
    contactData,
    setContactData,
    showVoiceCallModal,
    setShowVoiceCallModal,
    showCallingAgentIconOnWorkspace,
    setShowCallingAgentIconOnWorkspace,
    allBlogs,
    setAllBlogs,
    selectedAvatarForHeygenVideo,
    setSeletedAvatarForHeygenVideo,
    selectedAvatarVoiceForHeygenVideo,
    setSeletedAvatarVoiceForHeygenVideo,
    voiceEmotionForHeygen,
    setVoiceEmotionForHeygen,
    voicePitchForHeygen,
    setVoicePitchForHeygen,
    voiceSpeedForHeygen,
    setVoiceSpeedForHeygen,
    allHeygenVideoAvatarList,
    setAllHeygenVideoAvatarList,
    allHeygenVideoVoiceList,
    setAllHeygenVideoVoiceList,
    selectedBgColorForHeygenVideo,
    setSeletedBgColorForHeygenVideo,
    captionForHeygenVideo,
    setCaptionForHeygenVideo,
    heygenVideoTitle,
    setHeygenVideoTitle,
    heygenAvatarStyle,
    setHeygenAvatarStyle,
    heygenAvatarScale,
    setHeygenAvatarScale,
    heygenAvatarOffset,
    setHeygenAvatarOffset,
    heygenVideoDimension,
    setHeygenVideoDimension,
    uploadedImageData,
    setUploadedImageData,
    heygenVideoPersonalAvatarImageId,
    setHeygenVideoPersonalAvatarImageId,
    isModalOpenForAvatarGenerationOption,
    setIsModalOpenForAvatarGenerationOption,
    showAvatarCreation,
    setShowAvatarCreation,
    heygenVideoWidth,
    setHeygenVideoWidth,
    heygenVideoHeight,
    setHeygenVideoHeight,
    selectedVideoResolution,
    setSelectedVideoResolution,
    setHeygenVideoPersonalAvatarGroupId,
    allHeygenVideovoices, setAllHeygenVideovoices,
    veoVideoResolution, setVeoVideoResolution,
    veoVideoPeopleAndFaces, setVeoVideoPeopleAndFaces,
    selectedLLMModal, setSelectedLLMModal,
    levelOfTextDetail, setLevelOfTextDetail,
    selectedTone, setTone,
    audience, setAudience,
    language, setLanguage,
    imageSource, setImageSource,
    imageStyle, setImageStyle,
    pptImageModel, setPPTImageModel,
    slideCount, setSlideCount,
    themeStyle, setThemeStyle,
    typographyStyle, setTypographyStyle,
    layoutStyle, setLayoutStyle,
    titleStyle, setTitleStyle,
    additionalInstructions, setAdditionalInstructions,
    alertCallPlace, setAlertCallPlace
  };

  return (
    <WorkspaceContext.Provider value={value}>
      {children}
    </WorkspaceContext.Provider>
  );
};

export default WorkspaceProvider;
